import React from "react";
import { useTranslation } from "react-i18next";

function ErrorBoundaryFallback() {
  const { t } = useTranslation("ui");
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-2">{t("errorBoundary.title")}</h1>
      <p className="text-sm text-muted-foreground">
        {t("errorBoundary.description")}
      </p>
    </div>
  );
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return <ErrorBoundaryFallback />;
    }
    return this.props.children;
  }
}
